import React from 'react';
import {useActivityLogsResults} from './activityLogsResultsHelper';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useResultsTableDropdownPosition} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import DropdownContainer from '../../../components/core/dropdown/DropdownContainer';
import DropdownRow from '../../../components/core/dropdown/DropdownRow';
import {helpContextPageUrl} from '../../../conf/Routes';

function ActivityLogsResults() {
    
    const { t } = useTranslation();
    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [dropdownLeft] = useResultsTableDropdownPosition();
    
    const {
        columns,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        tableContent,
        rowIdSelector,
        fetchNextPage,
        isFetching,
        isLastPage,
        isPageLoaded,
        selectedObjects,
        setSelectedObjects,
        sortBasis,
        sortDirection,
        setSort,
        columnsWidths,
        setColumnsWidths,
        reloadButtonOnClick,
        cancelSelected,
        clearFinished,
        toExcelAction
    } = useActivityLogsResults();

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.activityLogsResults}>        
            <div className="DrawResultsDiv">
                <div className="DrawResultsToolbar">
                    <SMCButton variant="ghost" icon="refresh" disabled={isFetching} onClick={reloadButtonOnClick}>{t('SMC_GEN_REFRESH')}</SMCButton>
                    {!isFetching && <span style={{ position: 'relative', top: '1px' }}>| {t('SMC_GEN_SHOWING')} {tableContent ? tableContent.length : 0} {t('SMC_GEN_RESULTS')}</span>}
                </div>
                <DropdownContainer style={{ left: dropdownLeft, position: 'absolute' }}>
                    <DropdownRow text={t('SMC_LOGSTASKS_CLEAR')} action={clearFinished} />
                    <DropdownRow text={t('SMC_LOGSTASKS_CANCEL')} action={cancelSelected} />
                    <DropdownRow text={t('SMC_GEN_EXCEL')} action={toExcelAction} />
                </DropdownContainer>
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    rowIdSelector={rowIdSelector}
                    allowRowWrap={true}
                />
            </div>
        </SMCPage>
    );
}

export default ActivityLogsResults;